<object *ngIf="src"
        type="application/pdf"
        [data]="src"
        width="100%"
        height="800">
</object>